/* One-time editorial reveal, with no dependency and no effect on other sections. */
(() => {
  if (customElements.get('blanc-art-of-scale')) return;

  class BlancArtOfScale extends HTMLElement {
    connectedCallback() {
      if (
        window.Shopify?.designMode ||
        !('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) return;

      this.classList.add('is-awaiting-reveal');
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.classList.remove('is-awaiting-reveal');
        this.observer?.disconnect();
        this.observer = null;
      }, { threshold: 0.12 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.classList.remove('is-awaiting-reveal');
    }
  }

  customElements.define('blanc-art-of-scale', BlancArtOfScale);
})();
